
import { SetupContext } from "vue";

import useAutoComplete from "composables/useAutoComplete";
import { Player } from "types/player";

interface Props {
  options: Player[];
  optionKey: string;
  label: string;
}

export default {
  name: "AutoCompleteChip",
  props: {
    options: {
      type: Array as () => Player[],
      required: true,
      default: [],
    },
    optionKey: {
      type: String,
      required: true,
      default: "email",
    },
    label: {
      type: String,
      required: true,
      default: "label",
    },
  },
  setup(props: Props, { emit }: SetupContext) {
    // Use AutoComplete composable
    const autoCompleteComp = useAutoComplete(props.options, props.optionKey);

    // Handle Tag selection
    const handleTagSelect = (value: Player) => {
      autoCompleteComp.selected(value);
      // Emit an event
      emit("on-tags-select", { playersOrder: autoCompleteComp.tags.value });
    };

    return {
      ...autoCompleteComp,
      handleTagSelect,
    };
  },
  emits: ["on-tags-select"],
};
